__turbopack_context__.v({
  "L": "Button-module-scss-module__ZzJ4MW__L",
  "M": "Button-module-scss-module__ZzJ4MW__M",
  "S": "Button-module-scss-module__ZzJ4MW__S",
  "app_light_theme": "Button-module-scss-module__ZzJ4MW__app_light_theme",
  "clear": "Button-module-scss-module__ZzJ4MW__clear",
  "content": "Button-module-scss-module__ZzJ4MW__content",
  "content__loading": "Button-module-scss-module__ZzJ4MW__content__loading",
  "disabled": "Button-module-scss-module__ZzJ4MW__disabled",
  "fullWidth": "Button-module-scss-module__ZzJ4MW__fullWidth",
  "icon__system": "Button-module-scss-module__ZzJ4MW__icon__system",
  "link": "Button-module-scss-module__ZzJ4MW__link",
  "loading": "Button-module-scss-module__ZzJ4MW__loading",
  "loadingIndicator": "Button-module-scss-module__ZzJ4MW__loadingIndicator",
  "outlined": "Button-module-scss-module__ZzJ4MW__outlined",
  "outlined-primary": "Button-module-scss-module__ZzJ4MW__outlined-primary",
  "primary": "Button-module-scss-module__ZzJ4MW__primary",
  "root": "Button-module-scss-module__ZzJ4MW__root",
  "secondary": "Button-module-scss-module__ZzJ4MW__secondary",
});
